<script setup>
import Alert from "@/components/common/Alert.vue";
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-dialog
	width="800px"
	v-model="open_flg"
>
<v-card
	width="800px"
>
<v-toolbar
	height="50px"
	color="#E11D31"
	dark
	flat
>
	<v-spacer />
	<v-icon
		@click="open_flg=false"
	>
		mdi-close
	</v-icon>
</v-toolbar>
<v-card-text class="mt-3 py-0" v-if="mode==0">
	既存リストに含まれる連絡先は無視されます。メディアリストを選択して追加ボタンを押下してください。
</v-card-text>
<v-card-text class="mt-3 py-0" v-else-if="mode==1">
	編集したいメディアリストを選択してください。
</v-card-text>
<v-card-text class="mt-3 py-0" v-else-if="mode==2">
	送信に使用するメディアリストを選択してください。
</v-card-text>
<v-card-text v-if="mlist.length==0">
<Alert
	messagetitle="メディアリストが保存されていません"
	message="候補ボックスからメディアリストを新規登録してください"
/>
</v-card-text>
<v-card-text class="py-0" v-else>
	<v-list>
        <v-radio-group
          v-model="selected_id"
          column
        >
		<v-list-item v-for="item,index in mlist" :key="index">
			<v-card width="100%" class="mb-2">
			<v-card-text>
			<v-row>
				<v-col cols="1">
					<v-radio
						color="red"
						:value="item.id"
					></v-radio>
				</v-col>
				<v-col cols="5">
					{{ item.label }}
				</v-col>
				<v-col>
					{{ item.cnt }}件
				</v-col>
				<v-col>
					{{ item.created_at }}
				</v-col>
			</v-row>
			</v-card-text>
			</v-card>
		</v-list-item>
		</v-radio-group>
	</v-list>
</v-card-text>
<v-card-actions class="pb-4" v-if="mlist.length!=0">
	<v-spacer />
	<v-btn
		color="#E11D31"
		dark
		@click="set"
		v-if="mode==0"
	>
		<v-icon>mdi-playlist-plus</v-icon>追加
	</v-btn>
	<v-btn
		color="#E11D31"
		dark
		@click="medialistopen"
		v-else-if="mode==1"
	>
		<v-icon>mdi-playlist-edit</v-icon>リストを編集する
	</v-btn>
	<v-btn
		color="#E11D31"
		:dark="!disable_flg"
		@click="mediaselect"
		v-else-if="mode==2"
		:disabled="disable_flg"
	>
		<v-icon>mdi-select</v-icon>使用する
	</v-btn>
	<v-spacer />
</v-card-actions>
</v-card>
</v-dialog>
</template>
<script>
export default {
	computed : {
		disable_flg : function(){
			let ret = true;
			if(this.selected_id != null)
			{
				ret = false;
			}
			return ret;
		},
	},
	data : function(){
		return {
			selected_id : null,
			open_flg : false,
			mlist     : [],
			mode     :  0,
		};
	},
	methods : {
		open : async function(mode=0){
            await axios.post("/api/media/medialist_existing")
            .then(response => {
				this.mlist = response.data;
				this.mode = mode;
				this.open_flg = true;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
		},
		mediaselect : function(){
			this.$emit("select",{id:this.selected_id});
			this.open_flg = false;
		},
		medialistopen : function(){
			let label = "";
			for(let i = 0 ; i < this.mlist.length ; i++)
			{
				if(this.mlist[i].id == this.selected_id)
				{
					label = this.mlist[i].label;
					break;
				}
			}
			this.$emit("open",{"list_id":this.selected_id,"list_title":label});
			this.open_flg=false;
		},
		set : async  function(){
			var params = new URLSearchParams();
			params.append("list_id",this.selected_id);
            await axios.post("/api/media/set_existing_list",params)
            .then(response => {
				this.$store.commit("mediacand/set_candlist",response.data);
				this.open_flg = false;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
		},
	},
}
</script>
